import React from 'react'
import ReactDOM from 'react-dom'
import Dotenv from 'dotenv'
import App from './App'
import * as serviceWorker from './serviceWorker'
import 'i18n'
import 'semantic-ui-css/semantic.min.css'

Dotenv.config()

// eslint-disable-next-line no-undef
ReactDOM.render(<App />, document.getElementById('root'))

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
